import { Component } from "../../../../../stateManager/store/formCreation_v2/types";

export const getChildren = (fields: string[], components: Component) => {
  const children: string[] = [];
  getChildrenHelper(fields, components, children);
  return children;
};

const getChildrenHelper = (
  fields: string[],
  components: Component,
  children: string[]
) => {
  fields.forEach((field) => {
    children.push(field);
    const component = components[field];
    if (Array.isArray(component?.fields) && component.fields.length) {
      getChildrenHelper(component.fields, components, children);
    }
  });
};
